import { useEffect, useState } from 'react';

type UpdateEffect = {
  fields: string[];
  timestamp: number;
};

export function useFieldUpdateHighlight({
  field,
  updateEffect,
}: {
  field: string;
  updateEffect?: UpdateEffect;
}): boolean {
  const [isAnimating, setIsAnimating] = useState(false);
  const isFocusedField = Boolean(updateEffect?.fields.includes(field));

  useEffect(() => {
    if (!isFocusedField) {
      setIsAnimating(false);

      return;
    }

    setIsAnimating(true);
    const timeout = window.setTimeout(() => {
      setIsAnimating(false);
    }, 1800);

    return () => window.clearTimeout(timeout);
  }, [field, isFocusedField, updateEffect?.timestamp]);

  return isAnimating;
}

export function getFieldUpdateHighlightProps(isAnimating: boolean): {
  borderColor: string;
  borderWidth: string;
  bg: string;
  boxShadow?: string;
  transition: string;
  animation?: string;
} {
  return {
    borderColor: isAnimating ? 'border.info' : 'transparent',
    borderWidth: isAnimating ? '1px' : '0',
    bg: isAnimating ? 'bg.subtle' : 'transparent',
    boxShadow: isAnimating
      ? '0 0 0 2px color-mix(in srgb, var(--colors-border-info) 35%, transparent)'
      : undefined,
    transition:
      'background-color 0.35s ease, border-color 0.35s ease, box-shadow 0.35s ease',
    animation: isAnimating
      ? 'objectContextFieldPulse 0.75s ease-in-out 2'
      : undefined,
  };
}
